import Vue from 'vue'
import Vuex from 'vuex'
import pageModule from './store.page'
import settingsModule from './store.settings'
import WelcomeBookauthModule from './store.WelcomeBookauth'
import PartnerStore from './partner.store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pageModule: pageModule,
    settingsModule: settingsModule,
    WelcomeBookauthModule: WelcomeBookauthModule,
    Partner: PartnerStore
  }
})

export default store
